/**
 * Версия сервиса — единый источник для API и веб-интерфейса.
 *
 * Совпадает с номером последней записи в журнале `docs/project-status.md`
 * («История изменений»). Правило: добавили запись в журнал — подняли эту
 * константу тем же номером.
 *
 * Не путать с `APP_VERSION` из окружения: туда релиз-скрипт кладёт git-тег
 * сборки (короткий sha) — он отдаётся в /health как `build`.
 */
export const APP_VERSION = '2.93';
//# sourceMappingURL=version.js.map